const orderManager = () => import('@/view/order/order-manager');
const liveOrderManager = () => import('@/view/order/live-order-manager');
const orderDetail = () => import('@/view/order/order-detail');
const orderManager2 = () => import('@/view/order/order-manager2');
const orderDetail2 = () => import('@/view/order/order-detail2');
const bind = () => import('@/view/order/bind');
const service = () => import('@/view/order/service');
const service2 = () => import('@/view/order/service2');
const service3 = () => import('@/view/order/service3');
const serviceDetail = () => import('@/view/order/service-detail');
const serviceDetail2 = () => import('@/view/order/service-detail2');
const tpOrderManager = () => import('@/view/order/tp-order-manager');
const tpOrderDetail = () => import('@/view/order/tp-order-detail');

export default [{
    path: '/order-manager',
    name: 'orderManager',
    component: orderManager
  },{
    path: '/live-order-manager',
    name: 'liveOrderManager',
    component: liveOrderManager
  },
  {
    path: '/order-detail',
    name: 'orderDetail',
    component: orderDetail
  },{
    path: '/order-manager2',
    name: 'orderManager2',
    component: orderManager2
  },
  {
    path: '/order-detail2',
    name: 'orderDetail2',
    component: orderDetail2
  },
  {
    path: '/bind',
    name: 'bind',
    component: bind
  },
  {
    path: '/service',
    name: 'service',
    component: service
  },
  {
    path: '/service2',
    name: 'service2',
    component: service2
  },
  {
    path: '/service3',
    name: 'service3',
    component: service3
  },
  {
    path: '/service-detail',
    name: 'serviceDetail',
    component: serviceDetail
  },
  {
    path: '/service-detail2',
    name: 'serviceDetail2',
    component: serviceDetail2
  },{
    path: '/tp-order-manager',
    name: 'tpOrderManager',
    component: tpOrderManager
  },{
    path: '/tp-order-detail',
    name: 'tpOrderDetail',
    component: tpOrderDetail
  },
];
